export default {
    dependencies: ['$element'],
    callable(ele) {
        const expandEle = ele.querySelector('[data-read-more-expand]');
        const abbrDescEle = ele.querySelector('[data-abbreviated-description]');
        const descEle = ele.querySelector('[data-description]');

        expandEle.addEventListener('click', expand);

        function expand() {
            abbrDescEle.remove();
            expandEle.remove();
            descEle.classList.remove('u-display-none');
            const scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            ele.focus();
            document.documentElement.scrollTop = document.body.scrollTop = scrollTop;
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/readMoreClick2.js